<template>
  <div
    v-loading="loading"
    style="width: 100%"
    class="loading-box"
    element-loading-text="生成中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.6)"
  />
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { upyunUrl } from '@/api/config'
import { exportWord } from '@/utils/docxExpos.js'
export default {
  data() {
    return {
      loading: false,
      id: null,
      templateId: 1, // 简历模版id
      resumeName: null, // 简历名称
      upyunData: { policy: '', signature: '' }
    }
  },
  computed: {
    ...mapState(['currentResumeInfo'])
  },
  created() {
    this.getUpYunSignFn()
    const obj = this.$route.query
    if (obj.id) this.id = obj.id // 内容id
    if (obj.templateId) this.templateId = obj.templateId // 简历模版id
    this.generateResumeFn()
  },
  methods: {
    ...mapActions([
      'getUpYunSign',
      'resumeGenerateSave',
      'getResumeGenerateContent',
      'videoUpyun'
    ]),
    // 获取又拍云签名
    async getUpYunSignFn() {
      this.upyunData = await this.getUpYunSign()
    },
    // 获取简历名字
    getName() {
      this.resumeName = this.currentResumeInfo.resume_name
      if (this.resumeName === null) {
        // 拼接导出文件名字
        this.resumeName = `${this.currentResumeInfo.name || 'xxx'}-${
            this.currentResumeInfo.intention.length
                ? this.currentResumeInfo.intention[0].intentionName
                : '岗位'
        }-${this.currentResumeInfo.num_work_experience || ''}年/${
            this.currentResumeInfo.education_experience.length
                ? this.currentResumeInfo.education_experience[0].end_time_year
                : ''
        }届毕业`
      }
    },
    // 生成简历
    async generateResumeFn() {
      this.loading = true
      // 获取最新简历的内容 进行word模板的赋值
      const obj = await this.getResumeGenerateContent({ id: this.id })
      this.getName()
      obj.intention.forEach((item) => {
        if (parseInt(item.maxwage)) {
          item['wage_name'] = item.minwage_name + '至' + item.maxwage_name
        } else {
          item['wage_name'] = item.minwage_name
        }
      })
      obj.education_experience.forEach((item) => {
        item['descriptions'] = item.description.split('\n')
      })
      obj.work_experience.forEach((item) => {
        item['descriptions'] = item.description.split('\n')
      })
      obj.project_experience.forEach((item) => {
        item['descriptions'] = item.description.split('\n')
      })
      obj.training_experience.forEach((item) => {
        item['descriptions'] = item.description.split('\n')
      })
      obj.skills_full.forEach((item) => {
        item['descriptions'] = item.description.split('\n')
      })
      const data = {
        name: obj.name, // 姓名
        gender: parseInt(obj.gender) === 1 ? '男' : '女', // 性别：0-未填写 1-男 2-女
        identity: obj.identity === 1 ? '在校生' : obj.identity === 2 ? '应届生' : '社会求职', // 身份
        dateOfBirth: obj.date_of_birth, // 出生日期
        age: obj.age, // 年龄
        birthplace: obj.birthplace, // 籍贯地区
        phoneNumber: obj.phone_number, // 手机号
        email: obj.email, // 邮箱
        resume_name: obj.resume_name, // 简历名称
        homePhoneNumber: obj.home_phone_number, // 固定电话
        numWorkExperience: obj.num_work_experience, // 工作年限
        QQ: obj.QQ,
        height: obj.height, // 身高
        wechat: obj.wechat, // vx
        weight: obj.weight, // 体重
        ethnic: obj.ethnic, // 名族
        currentLocation: obj.current_location, // 所在城市
        detailedLocation: obj.detailed_location, // 详细地址
        zipcode: obj.zipcode, // 邮编
        maritalStatus: obj.marital_status === '0' ? '未婚' : obj.marital_status === '1' ? '已婚' : obj.marital_status === '3' ? '离异' : obj.marital_status === '4' ? '再婚' : '', // 婚姻状况
        intention: obj.intention, // 求职意向数组
        education: obj.education_experience, // 教育经历数组
        workExperience: obj.work_experience, // 工作经历数组
        projectList: obj.project_experience, // 项目经历数组
        trainingList: obj.training_experience, // 培训经历数组
        skillsList: obj.skills_full, // 相关技能数组
        awardsList: obj.awards_full, // 荣誉奖项数组
        self_evaluation: obj.self_evaluation // 自我评价
      }
      let imgSize = {
        // 导出的word图片大小
        imgUrl: [100, 150]
        // imgUrl2: [200, 200]
      }
      const wordUrl = `./resumeTemplate${this.templateId}.docx`
      const file = await exportWord(wordUrl, data, this.resumeName + '.docx', imgSize)
      if (file) await this.fileUpyunFn(file)
    },
    // 文件上传又拍云
    async fileUpyunFn(file) {
      const data = new FormData()
      data.append('file', file)
      data.append('policy', this.upyunData.policy)
      data.append('signature', this.upyunData.signature)
      const res = await this.videoUpyun(data)
      const obj = {
        id: this.id,
        resume_url: upyunUrl + res.url,
        resume_name: this.resumeName,
        file_size: res.file_size,
        all_result_n: null
      }
      await this.resumeGenerateSaveFn(obj)
    },
    // 保存简历内容
    async resumeGenerateSaveFn(obj) {
      await this.resumeGenerateSave(obj)
      this.loading = false
      wx.miniProgram.redirectTo({
        url: `/pages/resumeSystem/myCurriculum/index?type=openWord`
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.loading-box
  position fixed
  left 0
  top 0
  width 100%
  height 100%
  z-index 10
</style>
